import { z } from 'zod';

// Odvetvové benchmarking (Týž. 19) — porovnanie firmy s priemerom firiem v tom istom
// NACE odvetví, ktoré majú finančné dáta. `peerCount` < 3 → priemery sú null
// (nedostatok dát na zmysluplné porovnanie, zobrazí sa len samotná hodnota firmy).
export const sectorBenchmarkSchema = z.object({
  naceName: z.string(),
  peerCount: z.number(),
  ownRevenue: z.number().nullable(),
  ownNetIncome: z.number().nullable(),
  ownEquity: z.number().nullable(),
  avgRevenue: z.number().nullable(),
  avgNetIncome: z.number().nullable(),
  avgEquity: z.number().nullable(),
  // NACE mediánové pomerové ukazovatele (2026-07-18) — jeden SQL percentile_cont
  // nad materializovanými latest* stĺpcami celého odvetvia (nie 30-peer vzorka ako
  // avg* vyššie), preto vlastný ratioPeerCount. Hodnoty sú podiely (0.42 = 42 %).
  ratioPeerCount: z.number(),
  ownDebtRatio: z.number().nullable(),
  ownRoe: z.number().nullable(),
  ownRoa: z.number().nullable(),
  ownMargin: z.number().nullable(),
  medianDebtRatio: z.number().nullable(),
  medianRoe: z.number().nullable(),
  medianRoa: z.number().nullable(),
  medianMargin: z.number().nullable(),
});
export type SectorBenchmark = z.infer<typeof sectorBenchmarkSchema>;
